import type { XandrKeywords } from '../types';

import { getRequestKeywords } from './getRequestKeywords';
import type { RequestKeywordsParams } from './buildRequestKeywords';

// VMAP entry point for the Swedish (Aftonbladet/SvD) brands. Same as
// `getRequestKeywords` (`kw_`-prefixed Xandr keywords only), except it omits
// the tcf/gdpr consent keywords, which are already handled at the top level
// of the VMAP request by the SVP player.
export async function getVmapKeywords(
  params: RequestKeywordsParams
): Promise<XandrKeywords> {
  return getRequestKeywords({ ...params, includeTcfConsent: false });
}
